export enum StatsigType {
    EXPERIMENT = 'experiment',
}
